function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n         .slider-logs-normal-1{fill:#75a1cf;}.slider-logs-normal-2{fill:#fff;}\n      "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "slider-logs-normal-1",
  d: "M303.19,409.44H286.91v23l21.13,0V414.49Zm-15.28,22v-21h13.71v4.75H307v16.2Z",
  transform: "translate(-286.91 -409.44)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "slider-logs-normal-1",
  x: 3.01,
  y: 6.98,
  width: 1.96,
  height: 1.96
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  className: "slider-logs-normal-1",
  x: 6.01,
  y: 6.98,
  width: 6,
  height: 1.96
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "slider-logs-normal-1",
  x: 3.01,
  y: 11.98,
  width: 1.96,
  height: 1.96
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "slider-logs-normal-1",
  x: 6.01,
  y: 11.98,
  width: 12,
  height: 1.96
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "slider-logs-normal-1",
  x: 3.01,
  y: 16.98,
  width: 1.96,
  height: 1.96
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "slider-logs-normal-1",
  x: 6.01,
  y: 16.98,
  width: 12,
  height: 1.96
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  className: "slider-logs-normal-2",
  points: "19.59 4.44 16.09 4.44 16.09 0.94 19.59 4.44"
});

var SvgLogs = function SvgLogs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "slider-logs-normal",
    viewBox: "0 0 21.13 22.97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logs.c3d0ab80.svg";
export { ForwardRef as ReactComponent };